import PeopleIcon from "@mui/icons-material/People";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ArticleIcon from "@mui/icons-material/Article";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import AssessmentIcon from "@mui/icons-material/Assessment";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import LegendToggleIcon from "@mui/icons-material/LegendToggle";
import SupportIcon from "@mui/icons-material/Support";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";

const menuitemsOptions = [
  {
    id: 0,
    name: "Dashboard",
    icon: <DashboardIcon fontSize="medium" />,
    link: "/",
    roles: [
      "Super Admin",
      "Admin",
      "Support Staff",
      "Psycho-ed",
      "Finance team",
      "Therapist",
      "Admission staff",
      "Medical Staff",
      "Hospitality Staff",
      "Clinical Director",
    ],
    gapAfter: true,
  },
  {
    id: 21,
    name: "My clients",
    icon: <PersonSearchIcon fontSize="medium" />,
    link: "/clients-filtered",
    roles: ["Therapist", "Super Admin"],
  },
  {
    id: 1,
    name: "All Client TH",
    icon: <PeopleIcon fontSize="medium" />,
    link: "/clients?tab=inhouse",
    roles: [
      "External",
      "Super Admin",
      "Admin",
      "Support Staff",
      "Psycho-ed",
      "Finance team",
      "Therapist",
      "Admission staff",
      "Medical Staff",
      "Hospitality Staff",
      "Clinical Director",
    ],
  },
  {
    id: 22,
    name: "All Client PH",
    icon: <PeopleIcon fontSize="medium" />,
    link: "/clients?rehab=ph&tab=inhouse",
    roles: [
      "External",
      "Super Admin",
      "Admin",
      "Support Staff",
      "Psycho-ed",
      "Finance team",
      "Therapist",
      "Admission staff",
      "Medical Staff",
      "Hospitality Staff",
      "Clinical Director",
    ],
    gapAfter: true,
  },
  {
    id: 2,
    name: "Notes",
    icon: <ArticleIcon fontSize="medium" />,
    link: "/notes",
    roles: [
      "Super Admin",
      "Admin",
      "Support Staff",
      "Psycho-ed",
      "Finance team",
      "Therapist",
      "Medical Staff",
      "Hospitality Staff",
      "Clinical Director",
    ],
    gapAfter: true,
  },
  {
    id: 16,
    name: "Room Layout",
    icon: <ViewModuleIcon fontSize="medium" />,
    link: "/roomlayout",
    roles: [
      "Super Admin",
      "Admin",
      "Support Staff",
      "Psycho-ed",
      "Finance team",
      "Therapist",
      "Medical Staff",
      "Hospitality Staff",
      "Clinical Director",
    ],
    gapAfter: true,
  },
  {
    id: 13,
    name: "Support Dashboard",
    icon: <SupportIcon fontSize="medium" />,
    link: "/supportdashboard",
    roles: [
      "Super Admin",
      "Admin",
      "Support Staff",
      "Finance team",
      "Psycho-ed",
      "Therapist",
      "Medical Staff",
      "Admission staff",
      "Hospitality Staff",
      "Clinical Director",
    ],
  },
  {
    id: 12,
    name: "Room bookings",
    icon: <LegendToggleIcon fontSize="medium" />,
    link: "/cheatsheet",
    roles: [
      "Super Admin",
      "Admin",
      "Support Staff",
      "Finance team",
      "Psycho-ed",
      "Therapist",
      "Medical Staff",
      "Admission staff",
      "Hospitality Staff",
      "Clinical Director",
    ],
  },
  {
    id: 5,
    name: "Room availability",
    icon: <AssessmentIcon fontSize="medium" />,
    link: "/availability",
    roles: ["Admin", "Super Admin", "Clinical Director", "Admission staff"],
    gapAfter: true,
  },
  {
    id: 3,
    name: "Documents",
    icon: <FolderOpenIcon fontSize="medium" />,
    link: "/documents",
    roles: [
      "Super Admin",
      "Admin",
      "Support Staff",
      "Psycho-ed",
      "Finance team",
      "Therapist",
      "Medical Staff",
      "Hospitality Staff",
      "Clinical Director",
      "Admission staff",
    ],
  },
  {
    id: 10,
    name: "Tutorials",
    icon: <VideoLibraryIcon fontSize="medium" />,
    link: "/tutorials",
    roles: [
      "Super Admin",
      "Admin",
      "Support Staff",
      "Psycho-ed",
      "Finance team",
      "Therapist",
      "Medical Staff",
      "Admission staff",
      "Hospitality Staff",
      "Clinical Director",
    ],
    gapAfter: true,
  },
  {
    id: 18,
    name: "Registration",
    icon: <PersonAddIcon fontSize="medium" />,
    link: "/registration",
    roles: [
      "Super Admin",
      "Admin",
      "Support Staff",
      "Psycho-ed",
      "Finance team",
      "Therapist",
      "Medical Staff",
      "Admission staff",
      "Hospitality Staff",
      "Clinical Director",
    ],
    gapAfter: true,
  },
  {
    id: 4,
    name: "Admissions",
    icon: <TrendingUpIcon fontSize="medium" />,
    link: "/salesteam",
    roles: ["Admin", "Super Admin", "Clinical Director", "Admission staff"],
  },
  {
    id: 20,
    name: "Daily Page Reads",
    icon: <AssessmentIcon fontSize="medium" />,
    link: "/dailyreads",
    roles: ["Super Admin"],
    gapAfter: true,
  },
  {
    id: 7,
    name: "My Profile",
    icon: <ManageAccountsIcon fontSize="medium" />,
    link: "/account",
    roles: [
      "Super Admin",
      "Admin",
      "External",
      "Support Staff",
      "Psycho-ed",
      "Finance team",
      "Therapist",
      "Normal User",
      "Admission staff",
      "Medical Staff",
      "Hospitality Staff",
      "Clinical Director",
    ],
  },
  {
    id: 8,
    name: "Roles",
    icon: <AdminPanelSettingsIcon fontSize="medium" />,
    link: "/roles",
    roles: ["Super Admin", "Clinical Director"],
  },
  {
    id: 9,
    name: "Export Data",
    icon: <SystemUpdateAltIcon fontSize="medium" />,
    link: "/export",
    roles: ["Admin", "Super Admin"],
  },
  {
    id: 11,
    name: "Staff contacts",
    icon: <ImportContactsIcon fontSize="medium" />,
    link: "/stafflist",
    roles: [
      "Super Admin",
      "Admin",
      "Support Staff",
      "Finance team",
      "Psycho-ed",
      "Therapist",
      "Medical Staff",
      "Admission staff",
      "Hospitality Staff",
      "Clinical Director",
    ],
  },
  {
    id: 17,
    name: "Email Templates",
    icon: <DescriptionIcon fontSize="medium" />,
    link: "/edit-email-template",
    roles: ["Super Admin"],
  },
  {
    id: 19,
    name: "Mobile App Settings",
    icon: <ManageAccountsIcon fontSize="medium" />,
    link: "/mobileappsettings",
    roles: ["Super Admin"],
    gapAfter: true,
  },
];

export default menuitemsOptions;
